import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import aboutImg from '../../../assets/images/brandIdentity/about.png';
import aboutItem1 from '../../../assets/images/brandIdentity/about-item-1.png';
import aboutItem2 from '../../../assets/images/brandIdentity/about-item-2.png';
import aboutItem3 from '../../../assets/images/brandIdentity/about-item-3.png';
import aboutItem4 from '../../../assets/images/brandIdentity/about-item-4.png';
import { BrandIdentityAboutStyles } from './styles';

export const BrandIdentityAbout = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <BrandIdentityAboutStyles>
      <div className="container">
        <h5>
          {getTranslationsByLangOrEng(interfaceLanguage, 'usage_attitude_4')}
        </h5>
        <div className="content">
          <img src={aboutImg} className="about-img" alt="" />
          <div className="cards">
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem1} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'brands_identity_4',
                  ),
                }}
              />
            </div>
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem2} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'brands_identity_5',
                  ),
                }}
              />
            </div>
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem3} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'brands_identity_6',
                  ),
                }}
              />
            </div>
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem4} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'brands_identity_7',
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </BrandIdentityAboutStyles>
  );
};
